import { createSelector } from '@reduxjs/toolkit'

import { getCollateral as getCollateralSlice } from '../root.selectors'

export const getHypothecCollaterals = createSelector(
  getCollateralSlice,
  (collateralSlice) => collateralSlice.hypothecCollaterals,
)
